export default "__VITE_ASSET__BbEDzgE2__"